import React, { createContext, useContext, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Tooltip.css'; // Import custom styles

interface TooltipContextType {
    showTooltip: (text: string, boundingRect: DOMRect) => void;
    hideTooltip: () => void;
}

const TooltipContext = createContext<TooltipContextType | null>(null);

import { ReactNode } from 'react';

export const TooltipProvider = ({ children }: { children: any }) => {
    const [tooltip, setTooltip] = useState({ text: '', x: 0, y: 0, visible: false });

    const showTooltip = (text: string, boundingRect: DOMRect) => {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Default tooltip position
        let x = boundingRect.left + boundingRect.width / 2; // Center horizontally
        let y = boundingRect.top; // Position above the parent

        // Estimate tooltip dimensions
        const estimatedTooltipWidth = 150; // Approximate width of tooltip in px
        const estimatedTooltipHeight = 40; // Approximate height of tooltip in px

        // Prevent overflow on the left side
        if (x - estimatedTooltipWidth / 2 < 0) {
            x = estimatedTooltipWidth / 2;
        }

        // Prevent overflow on the right side
        if (x + estimatedTooltipWidth / 2 > viewportWidth) {
            x = viewportWidth - estimatedTooltipWidth / 2;
        }

        // Prevent overflow at the top
        if (y - estimatedTooltipHeight < 0) {
            y = boundingRect.bottom + estimatedTooltipHeight; // Position below if above would overflow
        }

        setTooltip({
            text,
            x,
            y,
            visible: true,
        });
    };

    const hideTooltip = () => {
        setTooltip({ text: '', x: 0, y: 0, visible: false });
    };

    return (
        <TooltipContext.Provider value={{ showTooltip, hideTooltip }}>
            {children}
            {ReactDOM.createPortal(
                <div
                    className={`tooltip ${tooltip.visible ? 'visible' : ''}`}
                    style={{ left: tooltip.x, top: tooltip.y }}
                >
                    {tooltip.text.split('\\n').map((line, index) => (
                        //console.log('line: ', line, tooltip.text),
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </div>,
                document.body
            )}
        </TooltipContext.Provider>
    );
};

export const useTooltip = () => useContext(TooltipContext);
